export const COMPLETION_PENDING = 0;
export const COMPLETION_SUCCESS = 1;
export const COMPLETION_ERROR = 2;
export const COMPLETION_CANCEL = 3;